import { PostMessageServiceConfig, PostMessageRequest } from './types';
import { PostMessageSender } from './PostMessageSender';
import { PostMessageReceiver } from './PostMessageReceiver';
import { PostMessageRepository } from './PostMessageRepository';

export class PostMessageService {
  private readonly sender: PostMessageSender;
  private readonly receiver: PostMessageReceiver;
  private readonly config: PostMessageServiceConfig;
  private postMessageRepository: PostMessageRepository
  
  public constructor(
    config: PostMessageServiceConfig = {
      sourceWindow: window,
      targetWindow: window,
      targetOrigin: '*',
      timeout: 5000
    }
  ) {
    this.config = config;
    this.postMessageRepository = new PostMessageRepository();
    this.sender = new PostMessageSender(config.targetWindow, config.targetOrigin, this.postMessageRepository);
    this.receiver = new PostMessageReceiver(config.sourceWindow, config.targetOrigin, this.postMessageRepository);
    this.initialize();
  }

  private initialize(): void {
    this.receiver.initialize();
  }

  public async fetch(
    data: unknown,
    responseIdentifier: string
  ): Promise<MessageEvent> {
    return new Promise<MessageEvent>((resolve, reject) => {

      const timeout = setTimeout(() => {
        this.postMessageRepository.setPostMessageRequestStatus(responseIdentifier, 'TIMEOUT');
        reject(new Error('Timeout'));
      }, this.config.timeout);

      const postMessageRequest: PostMessageRequest = {
        data,
        responseIdentifier,
        status: 'CREATED',
        callback: (event) => {
            resolve(event);
            clearTimeout(timeout);
        }
      };
      
      this.postMessageRepository.storePostMessageRequest(postMessageRequest);
      this.sender.sendMessage(postMessageRequest);

    });
  }
}
